import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ChevronLeft, ChevronRight, Search } from 'lucide-react';
import CASINO_GAMES_CONFIG from '../../../../../config/casinoGamesConfig';

// Styled Components
const ProviderWrapper = styled.div`
  margin: 0px 0;
`;

const ProviderHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
`;

const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SearchWrapper = styled.div`
  position: relative;
  width: ${props => props.$isOpen ? '250px' : '0px'};
  height: 36px;
  overflow: hidden;
  transition: width 0.3s ease;
  margin-right: ${props => props.$isOpen ? '8px' : '0px'};
  
  @media (max-width: 768px) {
    width: ${props => props.$isOpen ? '200px' : '0px'};
  }
`;

const SearchInput = styled.input`
  width: 100%;
  height: 36px;
  background: rgba(50, 60, 70, 0.6);
  padding: 4px 12px 5px 40px;
  border: 1px solid rgba(224, 230, 233, 0.1);
  border-radius: 10px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: ${props => props.$isVisible ? 'translateX(0)' : 'translateX(20px)'};
  transition: all 0.3s ease;
  transition-delay: ${props => props.$isVisible ? '0.1s' : '0s'};

  &:focus {
    
    background: rgba(50, 60, 70, 0.8);
  }

  &::placeholder {
    color: #888;
    font-size: 13px;
  }

  @media(max-width:600px){
  margin-left: 0.5rem;
    width: 12rem;}
`;

const SearchInputIcon = styled(Search)`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 0.3s ease;
  transition-delay: ${props => props.$isVisible ? '0.1s' : '0s'};
`;

const IconBg = styled.div`
  padding: 6px 8px;
  background-color: ${props => props.$isSearchActive ? '#25EE89' : '#4a5354'};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  opacity: ${props => props.$isActive !== false ? 1 : 0.5};
  pointer-events: ${props => props.$isActive !== false ? 'auto' : 'none'};
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: ${props => {
      if (props.$isSearchActive) return '#25EE89';
      return props.$isActive !== false ? '#25EE89' : '#4a5354';
    }};
  }
`;

const ProviderGridContainer = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  height: 5rem;
  gap: 10px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    height: 4.5rem;
  }
`;

const ProviderGridItem = styled(Link)`
  flex: 0 0 auto;
  width: 157px;
  height: 13rem;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
 
  align-items: center;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 600px) {
    
     height: 10rem;
  }


`;

const ProviderLogo = styled.img`
  padding: 0.4rem;
  width: 100%;
  height: 37%;
  color: #df3131;
  object-fit: contain;
  border-radius: 8px;
  background: #314451;
`;

const NoResultsMessage = styled.div`
  text-align: center;
  color: #888;
  font-size: 16px;
  padding: 40px 0;
  width: 100%;
`;

class GameProviders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canScrollLeft: false,
      canScrollRight: false,
      searchQuery: '',
      isSearchOpen: false,
    };
    this.gridRef = React.createRef();
    this.searchInputRef = React.createRef();

    // Only show providers that have games in casinoGamesConfig
    const configCodes = new Set(CASINO_GAMES_CONFIG.map(p => p.name.toLowerCase().replace(/\s/g,'')));

    this.companies = [
      { name: 'Evolution Gaming', image: 'https://d3c3rwqla6qxaf.cloudfront.net/producer/88_evolution/asia_large/Evolution.svg', path: '/providers/evolution', configName: 'evolutiongaming' },
      { name: 'Ezugi',            image: '/assets/images/Providers/ezugi.png',           path: '/providers/ezugi',         configName: 'ezugi' },
      { name: 'Pragmatic Play',   image: '/assets/images/Providers/Pragmatic-play.avif', path: '/providers/pragmaticplay', configName: 'pragmaticplay' },
      { name: 'PG Soft',          image: '/assets/images/Providers/pgsoft.png',          path: '/providers/pgsoft',        configName: 'pgsoft' },
      { name: 'Jili Games',       image: '/assets/images/Providers/jili.png',            path: '/providers/jiligames',     configName: 'jiligames' },
      { name: 'Spribe',           image: '/assets/images/Providers/spribe.png',          path: '/providers/spribe',        configName: 'spribe' },
      { name: 'JDB',              image: '/assets/images/Providers/JDB.png',             path: '/providers/jdb',           configName: 'jdb' },
      { name: 'Pragmatic Live',   image: '/assets/images/Providers/Pragmatic-play.avif', path: '/providers/pragmaticlive', configName: 'pragmaticlive' },
      { name: 'NetEnt',           image: '/assets/images/Providers/netent.png',          path: '/providers/netentasia',    configName: 'evolution-netentasia' },
      // { name: 'Funky Games',      image: '/assets/images/Providers/funky.png',           path: '/providers/funkygames',    configName: 'funkygames' },
      // { name: 'VA',               image: '/assets/images/Providers/va.png',              path: '/providers/va',            configName: 'va' },
      // { name: 'Askmeslot',        image: '/assets/images/Providers/askmeslot.png',       path: '/providers/askmeslot',     configName: 'askmeslot' },
      { name: 'Playtech Asia',    image: '/assets/images/Providers/playtech.svg',        path: '/providers/ptasia',        configName: 'playtechasia' },
      // { name: 'Hacksaw World',    image: '/assets/images/Providers/hacksaw.png',         path: '/providers/hacksawworld',  configName: 'hacksawworld' },
      // { name: 'BNG',              image: '/assets/images/Providers/bng.png',             path: '/providers/bng',           configName: 'bng' },
      // { name: 'Rich88',           image: '/assets/images/Providers/rich88.png',          path: '/providers/rich88',        configName: 'rich88' },
      // { name: 'Pix',              image: '/assets/images/Providers/pix.png',             path: '/providers/pix',           configName: 'pix' },
      // { name: 'NextSpin',         image: '/assets/images/Providers/nextspin.png',        path: '/providers/nextspin',      configName: 'nextspin' },
      // { name: 'V8',               image: '/assets/images/Providers/v8.png',              path: '/providers/v8',            configName: 'v8' },
      { name: 'EvoPlay',          image: '/assets/images/Providers/evoplay.png',         path: '/providers/evoplayasia',   configName: 'evoplay' },
      { name: 'Onlyplay',         image: '/assets/images/Providers/onlyplay.png',        path: '/providers/onlyplay',      configName: 'onlyplay' },
      // commented = no games in config yet
      // { name: 'Platipus',      image: '/assets/images/Providers/platipus.webp',       path: '/providers/Platipus',      configName: 'platipus' },
      // { name: 'BGaming',       image: '/assets/images/Providers/bgaming.png',         path: '/providers/Bgaming',       configName: 'bgaming' },
      // { name: 'Amatic',        image: '/assets/images/Providers/amatic.png',          path: '/providers/Amatic',        configName: 'amatic' },
      // { name: 'Fugaso',        image: '/assets/images/Providers/fugaso.png',          path: '/providers/Fugaso',        configName: 'fugaso' },
      // { name: "Play'n GO",     image: '/assets/images/Providers/playngo.png',         path: '/providers/Playngo',       configName: 'playngo' },
      // { name: 'Iconic21',      image: 'https://d3c3rwqla6qxaf.cloudfront.net/producer/222_beterlive/asia_large/Beterlive.svg', path: '/providers/iconic21', configName: 'iconic21' },
      // { name: 'BetGames',      image: '/assets/images/Providers/betgames.webp',       path: '/providers/Betgames',      configName: 'betgames' },
      // { name: 'Quickspin',     image: '/assets/images/Providers/Quickspin.png',       path: '/providers/Quickspin',     configName: 'quickspin' },
      // { name: 'Relax Gaming',  image: '/assets/images/Providers/relaxgaming.png',     path: '/providers/relaxgaming',   configName: 'relaxgaming' },
      // { name: 'Endorphina',    image: '/assets/images/Providers/endorphina.png',      path: '/providers/Endorphina',    configName: 'endorphina' },
      // { name: 'Gamzix',        image: '/assets/images/Providers/gamzix.png',          path: '/providers/Gamzix',        configName: 'gamzix' },
      // { name: 'BTG',           image: '/assets/images/Providers/btg.svg',             path: '/providers/BTG',           configName: 'btg' },
      // { name: 'GameBeat',      image: '/assets/images/Providers/LogoGameBeat.png',    path: '/providers/Gamebeat',      configName: 'gamebeat' },
    ].filter(c => configCodes.has(c.configName));
  }

  componentDidMount() {
    this.updateScrollState();
    if (this.gridRef.current) {
      this.gridRef.current.addEventListener('scroll', this.updateScrollState);
    }
    // Add click outside listener
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    if (this.gridRef.current) {
      this.gridRef.current.removeEventListener('scroll', this.updateScrollState);
    }
    // Remove click outside listener
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  updateScrollState = () => {
    const grid = this.gridRef.current;
    if (!grid) return;

    const canScrollLeft = grid.scrollLeft > 0;
    const canScrollRight = grid.scrollLeft + grid.clientWidth < grid.scrollWidth;

    this.setState({ canScrollLeft, canScrollRight });
  };

  handleScroll = (direction) => {
    const grid = this.gridRef.current;
    if (!grid) return;

    const scrollAmount = 300;
    const newScrollPosition =
      direction === 'left'
        ? grid.scrollLeft - scrollAmount
        : grid.scrollLeft + scrollAmount;

    grid.scrollTo({ left: newScrollPosition, behavior: 'smooth' });
  };

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
    // Reset scroll position when searching
    if (this.gridRef.current) {
      this.gridRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    }
  };

  toggleSearch = () => {
    this.setState(prevState => {
      const newIsSearchOpen = !prevState.isSearchOpen;
      
      // If closing search, clear the search query
      if (!newIsSearchOpen) {
        return {
          isSearchOpen: newIsSearchOpen,
          searchQuery: ''
        };
      }
      
      return { isSearchOpen: newIsSearchOpen };
    }, () => {
      // Focus the input when opening search
      if (this.state.isSearchOpen && this.searchInputRef.current) {
        setTimeout(() => {
          this.searchInputRef.current.focus();
        }, 150); // Delay to allow animation to start
      }
    });
  };

  // Close search when clicking outside
  handleClickOutside = (event) => {
    if (this.state.isSearchOpen && 
        this.searchInputRef.current && 
        !this.searchInputRef.current.contains(event.target) &&
        !event.target.closest('[data-search-toggle]')) {
      this.toggleSearch();
    }
  };

  getFilteredCompanies = () => {
    const { searchQuery } = this.state;
    if (!searchQuery.trim()) {
      return this.companies;
    }
    
    return this.companies.filter(company =>
      company.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  render() {
    const { canScrollLeft, canScrollRight, searchQuery, isSearchOpen } = this.state;
    const filteredCompanies = this.getFilteredCompanies();

    return (
      <ProviderWrapper>
        <ProviderHeadingWrapper>
          <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#fff' }}>
             PROVIDERS {searchQuery && `(${filteredCompanies.length} found)`}
          </div>
          
          <HeaderRightSection>
            <SearchWrapper $isOpen={isSearchOpen}>
              <SearchInputIcon size={16} $isVisible={isSearchOpen} />
              <SearchInput
                ref={this.searchInputRef}
                type="text"
                placeholder="Search providers..."
                value={searchQuery}
                onChange={this.handleSearchChange}
                $isVisible={isSearchOpen}
              />
            </SearchWrapper>
            
            <IconBg
              data-search-toggle
              onClick={this.toggleSearch}
              $isSearchActive={isSearchOpen}
            >
              <Search size={18} color="white" />
            </IconBg>
            
            <IconBg
              onClick={() => this.handleScroll('left')}
              $isActive={canScrollLeft}
            >
              <ChevronLeft size={18} color="white" />
            </IconBg>
            
            <IconBg
              onClick={() => this.handleScroll('right')}
              $isActive={canScrollRight}
            >
              <ChevronRight size={18} color="white" />
            </IconBg>
          </HeaderRightSection>
        </ProviderHeadingWrapper>

        <ProviderGridContainer ref={this.gridRef}>
          {filteredCompanies.length > 0 ? (
            filteredCompanies.map((company, index) => (
              <ProviderGridItem
                key={`${company.name}-${index}`}
                to={company.path}
              >
                <ProviderLogo src={company.image} alt={company.name} />
              </ProviderGridItem>
            ))
          ) : (
            <NoResultsMessage>
              No providers found matching "{searchQuery}"
            </NoResultsMessage>
          )}
        </ProviderGridContainer>
      </ProviderWrapper>
    );
  }
}

export default GameProviders;